import React from 'react';

import styled from 'styled-components';

const Svg = styled.svg`
  width: 16px;
  height: 19px;
  flex-shrink: 0;
  aspect-ratio: 16/19;
  fill: var(--Fab-Core-Colors-Shadow, #1b1c19);
`;

const LockIcon = () => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      viewBox="0 0 16 19"
      fill="none"
    >
      <path
        d="M8 9.14815C7.43967 9.14835 6.89811 9.36138 6.47432 9.74832C6.05053 10.1353 5.7728 10.6702 5.6919 11.2555C5.611 11.8408 5.73233 12.4372 6.03372 12.9359C6.3351 13.4345 6.79641 13.802 7.33333 13.9712V15.4815C7.33333 15.6681 7.40357 15.8471 7.5286 15.9791C7.65362 16.111 7.82319 16.1852 8 16.1852C8.17681 16.1852 8.34638 16.111 8.47141 15.9791C8.59643 15.8471 8.66667 15.6681 8.66667 15.4815V13.9712C9.20359 13.802 9.6649 13.4345 9.96628 12.9359C10.2677 12.4372 10.389 11.8408 10.3081 11.2555C10.2272 10.6702 9.94947 10.1353 9.52568 9.74832C9.10189 9.36138 8.56033 9.14835 8 9.14815ZM8 12.6667C7.80222 12.6667 7.60888 12.6048 7.44443 12.4888C7.27998 12.3728 7.15181 12.2079 7.07612 12.0151C7.00043 11.8222 6.98063 11.6099 7.01921 11.4052C7.0578 11.2004 7.15304 11.0123 7.29289 10.8647C7.43275 10.7171 7.61093 10.6166 7.80491 10.5758C7.99889 10.5351 8.19996 10.556 8.38268 10.6359C8.56541 10.7158 8.72159 10.8511 8.83147 11.0247C8.94135 11.1983 9 11.4023 9 11.6111C9 11.8911 8.89464 12.1595 8.70711 12.3575C8.51957 12.5555 8.26522 12.6667 8 12.6667ZM14.6667 6.33333H12V4.22222C12 3.10242 11.5786 2.02848 10.8284 1.23666C10.0783 0.44484 9.06087 0 8 0C6.93913 0 5.92172 0.44484 5.17157 1.23666C4.42143 2.02848 4 3.10242 4 4.22222V6.33333H1.33333C0.979711 6.33333 0.640573 6.48161 0.390524 6.74555C0.140476 7.00949 0 7.36747 0 7.74074V17.5926C0 17.9659 0.140476 18.3238 0.390524 18.5878C0.640573 18.8517 0.979711 19 1.33333 19H14.6667C15.0203 19 15.3594 18.8517 15.6095 18.5878C15.8595 18.3238 16 17.9659 16 17.5926V7.74074C16 7.36747 15.8595 7.00949 15.6095 6.74555C15.3594 6.48161 15.0203 6.33333 14.6667 6.33333ZM5.33333 4.22222C5.33333 3.47569 5.61428 2.75973 6.11438 2.23185C6.61448 1.70397 7.29276 1.40741 8 1.40741C8.70724 1.40741 9.38552 1.70397 9.88562 2.23185C10.3857 2.75973 10.6667 3.47569 10.6667 4.22222V6.33333H5.33333V4.22222ZM14.6667 17.5926H1.33333V7.74074H14.6667V17.5926Z"
        fill="#1B1C19"
      />
    </Svg>
  );
};

export default LockIcon;
